import clsx from 'clsx'
import { memo, useEffect, useState } from 'react'

import { Authorization } from '@/widgets/Authorization'

import { Modal } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import { BonusPanelSkeleton } from './bonus-panel-skeleton'
import { useBonusPanelContent } from './hooks/use-bonus-panel-content'
import { useBonusPanelModal } from './hooks/use-bonus-panel-modal'

import cl from './bonuses-panel.module.scss'

type BonusPanelProps = {
	className?: string
	isAuthorized?: boolean
	isJuridicalUser?: boolean
	totalBonusesCount: number
	isLoading?: boolean
}

export const BonusesPanel = memo((props: BonusPanelProps) => {
	const { isLoading, className, isAuthorized, isJuridicalUser, totalBonusesCount } = props

	const { isModalOpen, openModal, closeModal, onAuthSuccess, isAuthorizedSuccessfully } =
		useBonusPanelModal(isAuthorized)
	const { title, subTitle } = useBonusPanelContent({ isAuthorized, isJuridicalUser, totalBonusesCount })

	const [rootOpen, setRootOpen] = useState(false)

	// Инициализация анимации
	useEffect(() => {
		setTimeout(() => setRootOpen(true), 1200)
	}, [])

	// Обработчик клика по панели
	const onClick = () => {
		if (!isAuthorizedSuccessfully) {
			openModal()
		}
	}

	const rootClasses = clsx(cl.root, className, {
		[cl.root__open]: rootOpen
	})

	const content = (
		<div className={cl.auth}>
			<Authorization onSuccess={onAuthSuccess} />
		</div>
	)

	return (
		<>
			<div className={rootClasses} onClick={onClick}>
				<div className={cl.wrapper}>
					<Icon name="IPortBonus" />
					<div className={cl.content}>
						{!isLoading && (
							<>
								<h3 className={cl.title}>{title}</h3>
								<p className={cl.text}>{subTitle}</p>
							</>
						)}
						{isLoading && <BonusPanelSkeleton />}
					</div>
				</div>
			</div>

			<Modal fullScreenOnMobile isOpen={isModalOpen} onClose={closeModal}>
				{content}
			</Modal>
		</>
	)
})
